import cn from "classnames";
import React, { useEffect, useCallback } from "react";

import styles from "./style.module.scss";

interface ModalProps {
  content: React.ReactNode | null;
  isEnableModalBackdropHide: boolean;
  dismiss: () => void;
  isFullScreenOnMobile?: boolean;
}

const Modal: React.FC<ModalProps> = (props: ModalProps) => {
  const {
    dismiss,
    content,
    isEnableModalBackdropHide,
    isFullScreenOnMobile,
  } = props;
  useEffect(() => {
    document.body.classList.add("modal-open");
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);
  const onOverlayClicked = useCallback(() => {
    if (!isEnableModalBackdropHide) {
      return;
    }
    dismiss();
  }, [dismiss, isEnableModalBackdropHide]);

  return (
    <>
      <div className={styles.overlay} onClick={onOverlayClicked} />
      <div
        className={cn(styles.content, {
          [styles.fullScreenOnMobile]: isFullScreenOnMobile,
        })}
      >
        {content}
      </div>
    </>
  );
};

export default Modal;
